import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Input, Space } from 'antd';
import { Link } from 'react-router-dom';

import { ExportDialog } from '@app/components';
import {
  ADD_CLIENT_LABEL,
  GET_CLIENTS_IMPORT_TEMPLATE_ENDPOINT,
  IMPORT_CLIENTS_PATH,
  TABLET,
} from '@app/constants';
import { useClientsAccessRights, useWindowSize } from '@app/hooks';

import { useExcelImport } from '@pages/Clients/ImportFromExcel/hooks/useExcelImport';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';

import type { MenuProps } from 'antd';

export const ClientsListHeader = () => {
  const { clientsData } = useNewClientsListContext();
  const { innerWidth } = useWindowSize();

  const { hasUserRightToExport, hasUserRightToCreate } =
    useClientsAccessRights();

  const {
    importInputRef,
    handleExportExcelTemplateClick,
    handleImportExcelClick,
    updateFileByExcel,
  } = useExcelImport({
    templateEndpoint: GET_CLIENTS_IMPORT_TEMPLATE_ENDPOINT,
    importPath: IMPORT_CLIENTS_PATH,
  });

  const items: MenuProps['items'] = [
    ...(hasUserRightToExport
      ? [
          {
            key: '1',
            label: (
              <ExportDialog
                searchId={clientsData?.Id}
                titleDataTestId={'export-popup-title'}
                modalDataTestId={'export-popup'}
                emailSubjectDataTestId="email-subject"
              />
            ),
          },
        ]
      : []),
    ...(hasUserRightToCreate
      ? [
          {
            key: '2',
            label: (
              <div
                onClick={() => handleExportExcelTemplateClick()}
                className="unselectable"
                data-testid="export-template"
              >
                <span>Выгрузить шаблон создания клиентов</span>
              </div>
            ),
          },
        ]
      : []),
    ...(hasUserRightToCreate
      ? [
          {
            key: '3',
            label: (
              <div
                onClick={() => handleImportExcelClick()}
                className="unselectable"
                data-testid="create-clients-excel"
              >
                <span>Создание клиентов через Excel</span>
                <Input
                  ref={importInputRef}
                  type="file"
                  style={{ display: 'none' }}
                  accept=".xlsx, .xls"
                  onChange={(e) => {
                    updateFileByExcel(e);
                  }}
                />
              </div>
            ),
          },
        ]
      : []),
  ];

  const isMobile = innerWidth <= TABLET;
  const label = isMobile ? '' : ADD_CLIENT_LABEL;
  // TODO временно скрываем
  // const dublicatesLength = 2;
  // const hasDublicates = dublicatesLength > 0;

  return (
    <>
      <Space size="middle">
        {/* TODO временно скрываем */}
        {/* {hasDublicates && (
          <Link to={DUBLICATE_CLIENTS_PATH}>
            <Flex gap={6}>
              <FontAwesomeIcon
                icon={faCopy}
                color="rgba(225, 79, 79, 1)"
                size="xl"
              />
              <Typography.Text style={{ color: 'rgba(225, 79, 79, 1)' }} strong>
                Дубликатов: {dublicatesLength}
              </Typography.Text>
            </Flex>
          </Link>
        )} */}
        {hasUserRightToExport && (
          <Dropdown menu={{ items }}>
            <Button data-testid="excel-operations">
              <Space>
                {isMobile ? (
                  <FontAwesomeIcon icon={faFileExcel} size={'lg'} />
                ) : (
                  <>
                    Операции с Excel
                    <DownOutlined />
                  </>
                )}
              </Space>
            </Button>
          </Dropdown>
        )}
        {hasUserRightToCreate && (
          <Link to="/clients/add">
            <Button
              id="test-button-to-add-client"
              type="primary"
              icon={<PlusOutlined />}
              data-testid="add-client-button"
            >
              {label}
            </Button>
          </Link>
        )}
      </Space>
    </>
  );
};
